export default __webpack_public_path__ + "static/media/discord-icon.fd35dea8.svg";